import { render, staticRenderFns } from "./CreatePerformanceReportSectionPage.vue?vue&type=template&id=2f9e99aa&scoped=true"
import script from "./CreatePerformanceReportSectionPage.vue?vue&type=script&lang=js"
export * from "./CreatePerformanceReportSectionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e99aa",
  null
  
)

export default component.exports